import { loggedInUser, loginMethod } from "src/types";
import { Suspense, useState } from "preact/compat";
import {
  getAuth,
  setPersistence,
  browserSessionPersistence,
  browserLocalPersistence,
} from "firebase/auth";

import { lazy } from "preact-iso";

const AuthForm = lazy(() => import("./form"));

interface Props {
  currentUser?: loggedInUser;
  onClick?: () => void;
  asMobile?: boolean;
}

const persistLogin = true;

const lastLoginMethod = (
  typeof localStorage !== "undefined"
    ? localStorage.getItem("lastLoginMethod")
    : null
) as loginMethod | null;

export const Auth = ({ currentUser, onClick, asMobile }: Props) => {
  const auth = getAuth();
  const [open, setOpen] = useState(false);

  if (persistLogin) {
    setPersistence(
      auth,
      persistLogin ? browserLocalPersistence : browserSessionPersistence
    );
  }

  const doLogout = () => {
    getAuth().signOut();
    if (onClick) {
      onClick();
    }
    location.reload();
  };

  if (currentUser) {
    return (
      <a onClick={doLogout} href="#" rel="nofollow">
        Log out
      </a>
    );
  } else {
    return (
      <>
        <a
          onClick={() => {
            setOpen(true);
          }}
          rel="nofollow"
        >
          Log in
        </a>
        {open && (
          <Suspense fallback={""}>
            <AuthForm
              defaultMethod={lastLoginMethod || "Google"}
              asMobile={asMobile}
              close={() => setOpen(false)}
            />
          </Suspense>
        )}
      </>
    );
  }
};
